<div class="header-container">
  <div class="left-column">
    <span>{{'Add Hazard Details' | translate}}</span>
  </div>
  <div class="right-column">
    <ion-button class="app-large-btn float-right margin-top-12" shape="round" fill="outline" color="primary"
      (click)="openAddHazard()">
      {{ 'New Hazard' | translate }}
    </ion-button>
    <img tooltip="{{'Close' | translate }}" placement="bottom" src="/assets/icon/cancel.svg" class="close-icon" alt=""
      (click)="close()">
  </div>
</div>

<div class="body-container scrollVertical">
  <div *ngIf="roadmap.length === 0" class="no-hazard-available">
    <span class="section-title">{{'No Hazards Available' | translate}}</span>
  </div>
  <div *ngFor="let section of roadmap" class="section-container">
    <span class="section-title">{{'Section' | translate}}: {{section.sectionName}}</span>
    <span class="sub-section-title">{{'Subsection' | translate}}: {{section.subSectionName}}</span>
    <span class="step-title">{{'Steps' | translate}}: {{section.stepName}}</span>
    <div class="hazard-container" *ngFor="let hazard of section.hazards"
      [ngStyle]="{'border-right': '7px solid ' + (hazard.completionStatus === 'Completed' ? 'var(--g-200-light-green)' : 'var(--y-400-mustard)')}">
      <input type="checkbox" #copyHazard id="copyHazard" title="checkbox" 
        [(ngModel)]="hazard.isChecked"
        (change)="updateHazard(section.stepId, section.hazards, hazard, $event.target.checked)" class="hazard-checkbox">
      <label for="copyHazard" class="step-title">
        {{hazard.hazardName}}
      </label>
    </div>
  </div>
</div>
<div class="add-hazard-btn">
  <ion-button class="app-large-btn float-right margin-top-12"
    [disabled]="isPayloadEmpty()" shape="round" fill="outline" color="primary"
    (click)="addCopiedHazard()">
    {{ 'Add' | translate }}
  </ion-button>
</div>